// extracted by mini-css-extract-plugin
export default {"row":"TemplateModal_row__uEjSW","list":"TemplateModal_list__rK7Cc","unitValue":"TemplateModal_unitValue__EYaZh"};